import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { Box } from '@mui/material'
import { BatchSettingsTable } from 'Features/Projects/Scenarios/EditSettings/LineSettings/BatchSettings/BatchSettings.Table'
import { useWindowSize } from 'Common/hooks/useWindowSize.hook'
import { max } from 'lodash'
import { useBatchSettings } from '../LineSettings.data'
import { useParams } from 'react-router-dom'
import { Loader } from 'Common/Loader/Loader'
import { EditSettingsDataFilter } from '../../EditSettings.DataFilter'
import { useSettingsContext } from '../../EditSettings.types'
import { useMemo } from 'react'

export const BatchSettingsView = () => {
  const { projectId, scenarioId } = useParams() as {
    projectId: string
    scenarioId: string
  }

  const { view_width, view_height } = useWindowSize()
  const { state } = useSettingsContext()
  const { selectedBaseSourceSite, selectedWorkCentre } = state

  const { data: batchSettings, isLoading } = useBatchSettings({
    projectId,
    scenarioId,
  })

  const filteredBatchSettings = useMemo(() => {
    if (!batchSettings) return []
    
    let filtered = batchSettings
    
    // Filter by baseSourceSite
    if (selectedBaseSourceSite && selectedBaseSourceSite !== 'All') {
      filtered = filtered.filter(
        (item) => item.baseSourceSiteCode === selectedBaseSourceSite
      )
    }
    
    // Filter by workCentre  
    if (selectedWorkCentre && selectedWorkCentre !== 'All') {
      filtered = filtered.filter(
        (item) => item.workCentreCode === selectedWorkCentre
      )
    }
    
    return filtered
  }, [batchSettings, selectedBaseSourceSite, selectedWorkCentre])

  return (
    <Page>
      <Box
        display="flex"
        flex="auto"
        flexDirection="column"
        justifyContent="flex-start"
        maxWidth={view_width}
        maxHeight={max([view_height, 1500])}
      >
        <PageHeader
          title="Batch Production"
          rightElement={<EditSettingsDataFilter />}
        />
        {isLoading ? (
          <Loader />
        ) : (
          <BatchSettingsTable
            data={filteredBatchSettings}
            isLoading={isLoading}
          />
        )}
      </Box>
    </Page>
  )
}
